export default __webpack_public_path__ + "static/media/indent-rtl.0752a237.svg";